// Shared flag: true only while a native OAuth flow opened the in-app browser.
let inProgress = false;
export const setOAuthInProgress = (value: boolean) => { inProgress = value; };
export const isOAuthInProgress = () => inProgress;
